// Constants for the gamification system
export const CONSTANTS = {
  MAX_SESSION_MINUTES: 180,
  MAX_SESSIONS_PER_DAY: 24,
  DAILY_GOAL_MINUTES: 120,
  BREAK_REQUIRED_MINUTES: 5,
  PAUSE_TIMEOUT_MINUTES: 30,
  XP_PER_MINUTE: 1,
  STARS_PER_30_MINUTES: 1,
  STREAK_RESET_HOURS: 24,
  WEEK_RESET_DAYS: 7,
  BREAK_CALCULATION: {
    MIN_BREAK: 5,
    MAX_BREAK: 20,
    RATIO: 0.2,
    PREMIUM_MIN: 3,
    PREMIUM_MAX: 25,
  },
  BREAK_COINS: {
    FULL_BREAK: 2,
    EARLY_RETURN: 1,
    SKIPPED: 0,
    ACTIVITY_BONUS: 0.5,
    MAX_ACTIVITY_BONUSES: 2,
  },
};

// Forge Heat System - Controls break skipping behavior
// Heat increases when skipping breaks, decreases when taking breaks
export const FORGE_HEAT = {
  MAX: { free: 4, premium: 8 },           // Maximum heat before skip disabled
  SKIP_COST: { free: 2, premium: 1 },     // Heat added per skip
  BREAK_RECOVERY: { free: 1, premium: 2 }, // Heat removed per break
  FLOOR: 0,                                // Minimum heat (can't go below)
} as const;

// Study category system
export const DEFAULT_CATEGORIES = [
  'Math',
  'Science',
  'Reading & Literature',
  'Writing',
  'Coding & Programming',
  'Test Prep',
  'Language Learning',
  'Work & Career',
  'Creative Projects',
  'Notes & Review',
  'Other'
] as const;

export const MAX_CUSTOM_CATEGORIES = 10;
